module.exports = __webpack_public_path__ + "static/media/download_excel.82c36710.svg";